import 'uni-pages';import 'uni-h5';import Vue from 'vue'
import App from './App'
import uView from 'uview-ui';
Vue.use(uView);
Vue.config.productionTip = false
import store from './store';
import moment from "moment";
import themeMixin from '@/mixins/theme.js';
// 全局注册主题混合
Vue.mixin(themeMixin);
import AsyncLoading from '@/components/AsyncLoading.vue'
// 全局注册组件
Vue.component('AsyncLoading', AsyncLoading)
Vue.prototype.$store = store;
// uni.setInnerAudioOption ({obeyMuteSwitch: false}); //（仅在 iOS 生效）是否遵循静音开关，设置为 false 之后，即使是在静音模式下，也能播放声音
import JsBridge from "@/service/jsbridge"
import { isWxMpWebview } from '@/utils/env'

Vue.prototype.$jsbridge = JsBridge;

import fullCalendar from 'vue-fullcalendar'

Vue.component('full-calendar', fullCalendar)
// 将 Moment.js 挂载到 Vue 原型上
Vue.prototype.$moment = moment;

App.mpType = 'app'

function isPromise(obj) {
  return (
    !!obj &&
    (typeof obj === "object" || typeof obj === "function") &&
    typeof obj.then === "function"
  );
}

uni.addInterceptor({
  returnValue(res) {
    if (!isPromise(res)) {
      return res;
    }
    return new Promise((resolve, reject) => {
      res.then((res) => {
        if (res[0]) {
          reject(res[0]);
        } else {
          resolve(res[1]);
        }
      });
    });
  },
});

if (isWxMpWebview()) {
  renderVue()
} else {
  let isOpend = false
  JsBridge.getNativeInfo().then(data => {
    store.dispatch('setNativeInfo', data)
    localStorage.setItem('NATIVE_INFO', JSON.stringify(data))
    isOpend = true
    renderVue()
  })

  setTimeout(() => {
    if(!isOpend) {
      const nativeInfo = window.localStorage.getItem('NATIVE_INFO')
      if (nativeInfo) {
        try {
          store.dispatch('setNativeInfo', JSON.parse(nativeInfo))
        } catch (error) {

        }
      }
      renderVue()
    }
  }, 500)
}

// 防止重复点击
Vue.directive("preventReClick", {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      if (el.style.pointerEvents !== "none") {
        el.style.pointerEvents = "none"
        setTimeout(() => {
          el.style.pointerEvents = ""
        }, 5000)
      }
    })
  }
})
// 阿里云 RUM
import ArmsRum from '@arms/rum-browser';
ArmsRum.init({
  "pid": "da71k5hxwf@6af4ceab7f6a265",
  "endpoint": "https://da71k5hxwf-default-cn.rum.aliyuncs.com",
  // 链路追踪配置开关，默认关闭
  env: process.env.VUE_APP_TRACK_ENV,
  tracing: {
    enable: true, // 开启链路追踪，默认关闭
    sample: 100, // 采样率，默认100%
    tracestate: true, // 开启tracestate透传，默认开启
    baggage: true, // 开启baggage透传，默认关闭
    allowedUrls:[
      {match: process.env.VUE_APP_BASE_API, propagatorTypes:['tracecontext', 'b3']}, // 字符匹配 https://api.aliyun.com开头，使用w3c标准
      {match: process.env.VUE_APP_TRENDS_BASE_API, propagatorTypes:['tracecontext', 'b3']}, // 字符匹配 https://api.aliyun.com开头，使用w3c标准
      {match: process.env.VUE_APP_WU_YANG_BASE_API, propagatorTypes:['tracecontext', 'b3']}, // 字符匹配 https://api.aliyun.com开头，使用w3c标准
      {match: process.env.VUE_APP_LAIKANG_API, propagatorTypes:['tracecontext', 'b3']}, // 字符匹配 https://api.aliyun.com开头，使用w3c标准
    ],
  },
  //
  user: {
    name: uni.getStorageSync("wxUserInfoSync").userName,
    tags: 'tags_'+uni.getStorageSync("wxUserInfoSync").userId,
  },
});
function renderVue() {
  const app = new Vue({
    ...App
  })
  console.log('helloi', app)
  app.$mount()
}